/**
 * Schleiquartiere Frontend JavaScript
 * Bootstrap 5 + jQuery 3.7.1 (für Fewo-Manager Plugin) + Custom JS
 */

// Import jQuery (benötigt vom Fewo-Manager Plugin)
import $ from 'jquery';

// Import Bootstrap 5 JS
import * as bootstrap from 'bootstrap';

// Import Main SCSS
import '../scss/app.scss';

// Make jQuery & Bootstrap available globally (für Fewo-Manager Plugin & Legacy-Code)
window.$ = window.jQuery = $;
window.bootstrap = bootstrap;

/**
 * Initialize Bootstrap Components & Lightbox
 */
document.addEventListener('DOMContentLoaded', function() {

    // Initialize all tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(el => new bootstrap.Tooltip(el));

    // Initialize all popovers
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.map(el => new bootstrap.Popover(el));

    // Initialize all toasts
    const toastElList = [].slice.call(document.querySelectorAll('.toast'));
    toastElList.map(toastEl => new bootstrap.Toast(toastEl));

    // FsLightbox initialisiert sich selbst (kein manueller Call nötig)
});

/**
 * Close responsive menu when a link is clicked
 */
document.querySelectorAll('.navbar-nav .nav-link').forEach(link => {
    link.addEventListener('click', function() {
        const navbarCollapse = document.querySelector('.navbar-collapse');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            const bsCollapse = bootstrap.Collapse.getInstance(navbarCollapse);
            if (bsCollapse) {
                bsCollapse.hide();
            }
        }
    });
});

/**
 * Testimonials - Read More Functionality - Initial Load
 */
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        initReadMoreButtons();
    });
})();

/**
 * Fix Bewertungen Slider Buttons After AJAX Updates
 * Plugin returns old buttons after AJAX - replace with Bootstrap 5 styled buttons
 */
$(document).on('ajaxUpdate', function(event, context, data, textStatus, jqXHR) {
    // Check if bewertungen container was updated
    if (context && (context.handler === 'ObjektBewertungen::onBewLeft' || context.handler === 'ObjektBewertungen::onBewRight')) {
        setTimeout(function() {
            fixBewertungenButtons();
            initReadMoreButtons();
        }, 100);
    }
});

function fixBewertungenButtons() {
    const container = document.querySelector('#bewertungen-container');
    if (!container) return;

    // Fix left button
    const btnLeft = container.querySelector('#btn-bewleft button');
    if (btnLeft && (btnLeft.classList.contains('btn-left') || btnLeft.classList.contains('btn-info'))) {
        btnLeft.className = 'btn btn-outline-primary btn-lg';
        btnLeft.innerHTML = '<i class="fa-solid fa-chevron-left"></i>';

        // Update button wrapper styling
        const btnLeftWrapper = container.querySelector('#btn-bewleft');
        if (btnLeftWrapper) {
            btnLeftWrapper.style.position = 'absolute';
            btnLeftWrapper.style.left = '0';
            btnLeftWrapper.style.top = '50%';
            btnLeftWrapper.style.transform = 'translateY(-50%)';
        }
    }

    // Fix right button
    const btnRight = container.querySelector('#btn-bewright button');
    if (btnRight && (btnRight.classList.contains('btn-right') || btnRight.classList.contains('btn-info'))) {
        btnRight.className = 'btn btn-outline-primary btn-lg';
        btnRight.innerHTML = '<i class="fa-solid fa-chevron-right"></i>';

        // Update button wrapper styling
        const btnRightWrapper = container.querySelector('#btn-bewright');
        if (btnRightWrapper) {
            btnRightWrapper.style.position = 'absolute';
            btnRightWrapper.style.right = '0';
            btnRightWrapper.style.top = '50%';
            btnRightWrapper.style.transform = 'translateY(-50%)';
        }
    }
}

/**
 * Initialize "Read More" buttons for long reviews
 */
function initReadMoreButtons() {
    const reviewItems = document.querySelectorAll('.bew-item');

    reviewItems.forEach(item => {
        const reviewText = item.querySelector('.review-text');
        const btnReadMore = item.querySelector('.btn-read-more');

        if (!reviewText || !btnReadMore) return;

        // Check if text is clamped (overflow)
        const isClamped = reviewText.scrollHeight > reviewText.clientHeight;

        if (isClamped) {
            // Show button
            btnReadMore.style.display = 'inline-flex';

            // Remove old event listeners by cloning
            const newBtn = btnReadMore.cloneNode(true);
            btnReadMore.parentNode.replaceChild(newBtn, btnReadMore);

            // Toggle handler
            newBtn.addEventListener('click', function() {
                const isExpanded = reviewText.classList.contains('expanded');
                const labelMore = this.querySelector('.btn-read-more__label-more');
                const labelLess = this.querySelector('.btn-read-more__label-less');

                if (isExpanded) {
                    // Collapse
                    reviewText.classList.remove('expanded');
                    labelMore.style.display = 'inline';
                    labelLess.style.display = 'none';
                } else {
                    // Expand
                    reviewText.classList.add('expanded');
                    labelMore.style.display = 'none';
                    labelLess.style.display = 'inline';
                }
            });
        } else {
            // Hide button if text is not clamped
            btnReadMore.style.display = 'none';
        }
    });
}
